import { Box } from '@mui/material';
import SquaresWorkOrdersManagementHandler from 'handlers/squaresHandlers/sqauresWorkOrdersManagement.handler';
import { useCallback, useEffect, useState } from 'react';
import { useAppSelector } from 'store/hook';
import { WorkOrderCreationForm } from '../WorkOrderCreationAndUpdateForm/WorkOrderCreationForm';
import Table from './components/Table/Table';
import type { ServiceView } from 'types/survivalAnalysis.types';
import type { ComponentDetails } from 'types/squares.type';

type ViewType = 'tabular' | 'creation';
type ActionType = 'create' | 'update';

interface WorkOrdersCreatedProps {
  components: ComponentDetails[];
  asset: ServiceView | null;
  clearStateDefaultState: () => void;
}

const TabularView = ({
  handleCreateOrEditWorkOrderClick,
}: {
  handleCreateOrEditWorkOrderClick: (
    view: 'tabular' | 'creation',
    action: 'create' | 'update'
  ) => void;
}) => {
  const accessToken = useAppSelector((state) => state.authReducer.accessToken);
  const workOrdersManagementHandler = new SquaresWorkOrdersManagementHandler();
  useEffect(() => {
    if (accessToken) {
      void workOrdersManagementHandler.getAllWorkOrders();
    }
  }, [accessToken]);

  return (
    <Table
      handleCreateOrEditWorkOrderClick={handleCreateOrEditWorkOrderClick}
    />
  );
};

export const WorkOrdersCreated = ({
  components,
  asset,
  clearStateDefaultState,
}: WorkOrdersCreatedProps) => {
  const [data, setData] = useState<{
    view: ViewType;
    action: ActionType;
  }>({
    view: asset ? 'creation' : 'tabular',
    action: 'create',
  });
  const handleBackClick = useCallback((value?: string, action?: ActionType) => {
    if (value === 'creation') {
      setData((prev) => ({
        ...prev,
        view: 'tabular',
        action: 'create',
      }));
    } else {
      setData((prev) => ({
        view: 'creation',
        action: action ?? 'create',
      }));
    }
    clearStateDefaultState();
  }, []);

  useEffect(() => {
    if (asset) {
      setData({
        view: 'creation',
        action: 'create',
      });
    }
  }, [asset]);
  return (
    <Box width={'100%'} height={'100%'}>
      {/* <Table /> */}
      {data.view === 'tabular' && (
        <TabularView handleCreateOrEditWorkOrderClick={handleBackClick} />
      )}
      {data.view === 'creation' && (
        <WorkOrderCreationForm
          handleBackClick={handleBackClick}
          formType="create"
          formAction={data.action}
          components={components}
          asset={asset}
        />
      )}
    </Box>
  );
};
